import React from "react";
import "../Styles/Main_bg.css";
import "../styles2.css";
import bannerImg from "../assets/banner_img.jpg";
import calendarIcon from "../assets/schedule.png";
import checkIcon from "../assets/checked.png";
import bannerImg2 from "../assets/bannerImage2.svg";
import section2Img from "../assets/personImg.svg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const MainBg = () => {
  const user = useSelector((state) => state.auth.user);
  const loginState = user ? true : false;
  const navigation = useNavigate();
  const handleClick = (title, providerName) => {
    navigation(
      loginState ? "/Appointment" : "/Login",
      loginState && { state: { title, providerName } }
    );
  };

  return (
    <div class="home_div">
      <div class="container section1">
        <div class="banner_Container">
          <div class="content">
            <h1>Online Appointment Booking System for Medical Office</h1>
            <p>
              {" "}
              Simply define your services and providers, display their
              availability, and you will have clients both old and new making
              bookings 24/7.{" "}
            </p>
            <a
              onClick={() => handleClick("card.title", "card.providerName")}
              class="main_button_link"
            >
              Book Your Appointment
            </a>
          </div>
          <div class="bannerImage">
            <img src={bannerImg2} alt="Logo" />
          </div>
        </div>
      </div>
      <div class="container section2">
        <div class="banner_Container">
          <div class="bannerImage">
            <img src={section2Img} alt="Logo" />
          </div>
          <div class="content">
            <h1>How Our Booking System Works</h1>
            <p>
              {" "}
              Select your doctor, pick a convenient time, and confirm your
              appointment – all in a few clicks. Simple, fast, and hassle-free!{" "}
            </p>
            <ul class="icon_List">
              <li>
                <img src={calendarIcon} alt="Logo" />
                <span>Pick a Date and Time</span>
              </li>
              <li>
                <img src={checkIcon} alt="Logo" />
                <span>Confirm Your Appointment</span>
              </li>
            </ul>
            <a
              onClick={() => handleClick("card.title", "card.providerName")}
              class="main_button_link"
            >
              Get Started
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainBg;
